// Webpack 5 / CRA: no Node globals — @react-pdf/renderer expects Buffer in the browser.
import { Buffer } from 'buffer';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import reduxThunk from 'redux-thunk';

import 'materialize-css/dist/css/materialize.min.css';
import './utils/css/app/noDoubleUnderline.css';

import App from './components/App';
import reducers from './reducers';

window.Buffer = window.Buffer || Buffer;

const store = createStore(reducers, {}, applyMiddleware(reduxThunk));

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
	<Provider store={store}>
		<App />
	</Provider>
);
